import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setScreenSize } from '../../lib/screenSizeActions';

class ScreenSizeHandler extends Component {
    componentDidMount() {
        this.updateScreenSize();
        window.addEventListener('resize', this.updateScreenSize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScreenSize);
    }

    updateScreenSize = () => {
        const isLandscape = window.innerWidth > window.innerHeight;
        let newScreenSize = 'desktop';

        if (isLandscape) {
            newScreenSize = window.innerWidth < 933 ? 'mobile' : 'desktop';
        } else {
            if (window.innerWidth < 933) {
                newScreenSize = 'mobile';
            } else {
                newScreenSize = 'desktop'; 
            }
        }

        if (newScreenSize !== this.props.screenSize) {
            this.props.setScreenSize(newScreenSize);
        }
    };

    render() {
        return null;
    }
}

const mapStateToProps = (state) => ({
    screenSize: state.scratchGui.screenSize.screenSize,
});

const mapDispatchToProps = (dispatch) => ({
    setScreenSize: (size) => dispatch(setScreenSize(size)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScreenSizeHandler);
